<template>
    <div class="pandora-select-custom-container" v-if="props.datasource == 'front'">
        <div class="pandora-select-custom-label">
            <label :for="props.id">{{ props.label }}</label>
        </div>
        <select class="select-variant-default" ref="selectElement" @change="handlChange" :id="id" :aria-label="id"
            v-bind="$attrs" :value="modelvalue" :required="required">
            <slot></slot>
        </select>
        <img src="../../assets/arrow-down.png" class="select-arrow-donw" @click.prevent="openSelect" alt="arrow-select"
            width="auto" height="auto" />
    </div>
    <div class="pandora-select-custom-container" v-if="props.datasource == 'back'">
        <div class="pandora-select-custom-label">
            <label :for="props.id">{{ props.label }}</label>
        </div>
        <select class="select-variant-default" ref="selectElement" @change="handlChange" :id="props.id" :aria-label="id"
        v-bind="$attrs" :value="modelvalue" :required="props.required">
            <option v-for="option in processedData" :key="option.value" :value="option.value"> {{ option.label }}
            </option>
        </select>
        <img src="../../assets/arrow-down.png" class="select-arrow-donw" @click.prevent="openSelect" alt="arrow-select"
            width="16" height="16" />
    </div>
</template>
<script setup>
import '../../assets/css/config.css'
import { defineProps, ref, computed, defineEmits } from 'vue'
const props = defineProps({
    label: { type: String, default: "Label" },
    id: { type: String },
    name: { type: String },
    required: { type: Boolean, default: false },
    datasource: { type: String, default: 'front' },
    data: { type: Array },
    valuekey: { type: String },
    labelkey: { type: String },
    modelvalue: { type: String },
    onchange: { type: Function },
})
const selectElement = ref(null);
const emits = defineEmits(['update:modelvalue'])
const handlChange = (event) => {
    emits('update:modelvalue', event.target.value)
    selectElement.value.classList.add('option-selected');
    if (props.onchange) {
        props.onchange(event.target.value)
    }
}
//utilizar icono arrow para abrir el select
const openSelect = () => {
    if (selectElement.value.showPicker) {
        selectElement.value.showPicker();
    } else {
        selectElement.value.focus();
        selectElement.value.click();
    }
}
const processedData = computed(() => {
    return props.data.map(option => ({
        value: option[props.valuekey],
        label: option[props.labelkey]
    }));

})
</script>
<style>
.pandora-select-custom-container {
    position: relative;
    width: 100%;
}

.select-arrow-donw {
    transform: translateX(-10px) translateY(15px);
    position: absolute;
    right: 10px;
    z-index: 1;
    cursor: pointer;
    pointer-events: auto;
    font-size: 16px;

}

.select-variant-default {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    width: 100%;
    height: 40px;
    border-radius: 8px;
    border: 1px solid #CDCED9;
    background: transparent;
    background-color: white;
    cursor: pointer;
    font-family: Rubik, sans-serif;
    font-size: medium;
    padding-left: 16px;
    box-sizing: border-box;

}

.select-variant-default,
option {
    color: #6B6C7E;
}

.select-variant-default:focus {
    outline: none;
}

.option-selected {
    color: var(--color-black);
}

.pandora-select-custom-label {
    font-family: Rubik-semibold, sans-serif;
    color: var(--color-dark);
    margin-bottom: 4px;
}
</style>